import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import Footer from "../Component/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import { ExternalLink, Clock, Mail, Facebook, Linkedin, Instagram, Twitter,X, LogOut as UsersIcon } from "react-feather";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faXTwitter,   
} from "@fortawesome/free-brands-svg-icons";
import MyCustomForm from "../Component/MyCustomForm";


const FillCustomForm = () => {
  

  return (
    <>
      <NavbarVisitor />

      <div className="container-fluid"  style={{ backgroundColor: "#f3f3f3" }}>
        <div className="row justify-content-center mb-5 ">
          <div className="col-md-11 bg-white my-5">
          <MyCustomForm/>
          </div> 
        </div>
      </div>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default FillCustomForm;
